var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2 Q0 0 2 0 L15 0 L24 9 L24 28 Q24 30 22 30 L2 30 Q0 30 0 28 Z",
    fill: "#E53935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0 L15 9 L24 9 Z",
    fill: "#B71C1C"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 22,
    fontFamily: "Arial, sans-serif",
    fontSize: 7,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "PDF")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPdf);
export default __webpack_public_path__ + "static/media/document_pdf.e1a10e75d46abd4569f64f1c9bce2895.svg";
export { ForwardRef as ReactComponent };